module.exports = __webpack_public_path__ + "resources/img/sp_gamebase_m.45a7cbcbdc67cd749dec518198c59a58.png";